import React from 'react';
import Content from './Content';

class Appbar extends React.Component {
  render() {
    const { userProfile, title } = this.props;
    return (
      <Content userProfile={userProfile} title={title} />
    )
  }
}

export default Appbar;